import { navigate } from "gatsby";
import { Logout } from "../services/CurrentUser/currentUserDetails.js";

export const redirectToLoginPage = () => {
  Logout(function () {
    return true;
  }, false); // use demmu function for now
};

export const redirectToLoginPageFromLogout = () => {
  Logout(function () {
    return true;
  }, true); // use demmu function for now
};
